namespace Matrix.Rebalancer {
    export class TaskTypeColumns {
        static columnsKey = 'Rebalancer.TaskType';
    }
}
